module.exports = __webpack_public_path__ + "img/IMG_20200705_221807.496a4daf.jpg";